export const labelStyle = {
  fontFamily: 'Roboto',
  fontWeight: 400,
  fontSize: 16,
  color: 'rgba(0, 0, 0, 0.6)',
}

export const selectInputStyle = {
  'aria-label': 'Without label',
  fontSize: '16px',
}

export const selectMenuStyle = {
  style: {
    marginTop: 2,
    maxHeight: '510px',
    maxWidth: '200px',
  },
}

export const selectSxStyle = {
  mt: '2px',
  width: '220px',
  fontSize: '16px',
  fontStyle: 'normal',
  background: 'white',
  marginTop: 0,
  height: '40px',
}
